import { pathOr } from 'ramda';

import { IOffer } from '../../../types';

export const prepareOfferUrl = (offer: IOffer): string => {
  const isCianPartner = pathOr(false, ['isCianPartner'], offer);
  const externalOfferUrl = pathOr(null, ['externalOfferUrl'], offer);

  if (isCianPartner && externalOfferUrl) {
    return externalOfferUrl;
  }

  return `/${offer.dealType}/${offer.offerType}/${offer.id}`;
};
